import { Suspense } from 'react'
import { H3, Muted } from '@/components/sv/typographies'
import { Card, CardContent } from '@/components/ui/card'
import { Estimation } from '@/routes/apps/create-app/form/sections/overview/estimation'
import { OverviewFallback } from '@/routes/apps/create-app/form/sections/overview/fallback'

export const Overview = () => {
  return (
    <Card className="hidden lg:block">
      <CardContent>
        <div className="flex flex-col gap-4">
          <H3>Overview</H3>
          <div className="flex flex-col gap-6">
            <Suspense fallback={<OverviewFallback />}>
              <Estimation />
            </Suspense>
            <Muted>
              The above prices are estimates. They may vary based on your usage
              and the specific resources you choose. For more accurate pricing,
              please refer to our{' '}
              <a
                href="https://sevalla.com/pricing/"
                target="_blank"
                className="underline"
              >
                pricing page
              </a>
              .
            </Muted>
          </div>
        </div>
      </CardContent>
    </Card>
  )
}
